import { useState } from "react";
import { useSpring, animated } from "react-spring";

const AccordionItem = ({ title, content, price, titleColor, priceColor }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { height, opacity } = useSpring({
    from: { height: 0, opacity: 0 },
    to: {
      height: isOpen ? "auto" : 0,
      opacity: isOpen ? 1 : 0,
    },
    config: { duration: 300 },
  });

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="borderAc w-[100%] mb-[20px] cursor-pointer">
      {/* Header - Clickable area */}
      <div
        className="flex items-center justify-between w-[100%] mb-[10px]"
        onClick={toggleAccordion}
      >
        <p
          className={`md:text-[18px] sm:text-[16px] text-[15px] text-${titleColor} inter font-semibold`}
        >
          {title}
        </p>
        <p
          className={`md:text-[18px] sm:text-[16px] text-[15px] text-${priceColor} inter font-semibold`}
        >
          {price}
        </p>
      </div>

      {/* Content - Animated area */}
      <animated.div
        style={{
          height,
          opacity,
          overflow: "hidden",
        }}
      >
        {content && (
          <p className="text-warning inter md:text-[18px] sm:text-[16px] text-[15px] leading-[25px] mb-[10px]">
            {content}
          </p>
        )}
      </animated.div>
    </div>
  );
};

export default AccordionItem;
